const Suggestions = require('./suggestions');
const KeyCode = require('../ui/keycode');
const template = require('./search.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	// hmm ...
	// this.suggest = this.suggest || null;
	this.debounce_delay = 50;

	this.selected_item = null;

	this.__dom.item.onkeyup = function(e) {
		var e = new KeyCode(e || window.event);

		if (e.code == "Enter" || e.code == "NumpadEnter") {
			if (_t.selected_item) {
				open(_t.selected_item);
			} else {
				_t.startSearch(_t.getValue());
			}
			return;
		}

		if (e.code == 'ArrowDown') {
			if (_t.results) {
				_t.selected_item = _t.results.down();
			}
			return;
		}

		if (e.code == 'ArrowUp') {
			if (_t.results) {
				_t.selected_item = _t.results.up();
			}
			return;
		}

		if (typeof(_t.getResults) == 'function') {
			_t.selected_item = null;
			_t.startSearch(_t.getValue());
		}
	};

	// TODO: caching and deduplication ...
	this.startSearch = function(original_value) {
		var original = JSON.stringify(original_value);
		setTimeout(function() {
			var current = JSON.stringify(_t.getValue());
			if (current == original) {
				_t.search(original_value);
			}
		}, _t.debounce_delay);
	};

	this.suggest = function(results) {
		_t.results = new Suggestions(results);
		on(_t.results, 'select').then(function(item) {
			open(item);
		});
	};

	this.__dom.submit.onclick = function() {
		_t.search();
	};

	var search = function(v) {
		on(_t, 'search').fire(v);
	};

	var open = function(item) {
		if (_t.open) {
			_t.open(item);
		}
	};

	this.search = function(query, after, keep_url) {
		this.getResults(query, after, keep_url).then(_t.suggest);
		return;

		var v = this.getValue();
		if (v) {
			search(v);
		} else {
			this.reportValidationError();
			on(this, 'invalidEntry').fire(v);
		}
	};

	this.getValue = function() {
		if (this.format) {
			var match = this.validate();
			if (match) {
				return this.getObject(match);
			} else {
				return false;
			}
		} else {
			return this.item;
		}
	};

	this.validate = function() {
		var regex = new RegExp(this.format);
		var m = regex.exec(this.item);
		return m;
	};

	this.getObject = function(match) {
		if (this.output) {
			var rv = {};
			var fields = this.output.split(/,/);
			for (var i = 0; i < fields.length; i++) {
				rv[fields[i]] = match[i + 1];
			}
			return rv;
		} else {
			return match[0];
		}
	};

	this.clear = function() {
		this.item = '';
		this.results.items = [];
		TG.removeClassname(this, 'invalid-entry');
	};

	this.reportValidationError = function() {
		TG.addClassname(this, 'invalid-entry');
	}; 

	this.__dom.item.placeholder = this.placeholder;
	this.format = this['data-format'];
	this.output = this['data-output'];

	on(this.results, 'select').then(function(item) {
		open(item);
	});

});
